import React from 'react';
import CarCompleted from "../components/CarCompleted";

const CompletedCarPage = () => {
    return (
        <div className={'completed_cars_container'}>
            <CarCompleted />
        </div>
    );
};

export default CompletedCarPage;